import { useEffect, useState } from 'react';

type UseImageRotationReturn = {
    rotation: number;
    rotateLeft: () => void;
    rotateRight: () => void;
};

// Stores a cumulative (unbounded) degree value so that CSS transitions always
// animate in the correct direction: left = counter-clockwise (−90°), right = clockwise (+90°).
export const useImageRotation = (resetKey: unknown): UseImageRotationReturn => {
    const [rotation, setRotation] = useState(0);

    useEffect(() => {
        setRotation(0);
    }, [resetKey]);

    const rotateLeft = () => setRotation((r) => r - 90);
    const rotateRight = () => setRotation((r) => r + 90);

    return { rotation, rotateLeft, rotateRight };
};
